import { render, staticRenderFns } from "./DynamicsMigrationPlan.vue?vue&type=template&id=98cf9266&scoped=true"
import script from "./DynamicsMigrationPlan.vue?vue&type=script&lang=js"
export * from "./DynamicsMigrationPlan.vue?vue&type=script&lang=js"
import style0 from "./DynamicsMigrationPlan.vue?vue&type=style&index=0&id=98cf9266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cf9266",
  null
  
)

export default component.exports